<template>
  <div :id="domId" :style="sizeStyle" class="mx-auto xmov-qrcode"></div>
</template>

<script setup lang="ts" name="xQrcode">
const props = withDefaults(
  defineProps<{
    url: string
    size?: number
  }>(),
  {
    size: 150,
  }
)

const domId = ref(`qrcode_${Math.random()}`)

const sizeStyle = { width: `${props.size}px`, height: `${props.size}px` }

function genQrcode() {
  const el = document.getElementById(domId.value)
  if (el) {
    el.innerHTML = ''
  }

  const QRCode = window.QRCode as any

  if (QRCode) {
    new QRCode(el, {
      text: props.url,
      width: props.size,
      height: props.size,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H,
    })
  }
}

watch(() => props.url, genQrcode)

onMounted(genQrcode)
</script>

<style lang="scss">
.xmov-qrcode {
  pointer-events: none;
  user-select: none;
}
</style>
